import { useResetLocalToRemoteModal } from "components/GlobalModal/useResetLocalToRemoteModal";
import { useEditor } from "features/editor/Feature";
import { useSession } from "hooks/api/useSession";
import { useEffect } from "react";
import * as vscode from "vscode";

import { useAnalytics } from "hooks/useAnalytics";
import { useGitHubScopes } from "hooks/useGitHubScopes";

import type { Command } from "../../types";

export const useResetLocalToRemoteCommand = ({
  event_source,
}: {
  event_source: "topbar" | "command_palette";
}): Command => {
  const [_, sessionApi] = useSession();
  const project = useEditor();

  if (project.type === "sandbox") {
    throw new Error("You can not reset to remote on a Sandbox project");
  }
  const { isPrivate } = project;
  const gitHubScopes = useGitHubScopes();
  const track = useAnalytics();
  const resetLocalToRemoteModal = useResetLocalToRemoteModal();

  useEffect(() => {
    vscode.commands.executeCommand(
      "setContext",
      "codesandbox.git.resetLocalToRemote",
      true,
    );
  }, []);

  return {
    id: "codesandbox.git.resetLocalToRemote",
    section: "Git",
    name: "Reset Branch to Remote",
    perform: () => {
      if (!gitHubScopes?.publicRepos) {
        sessionApi.signIn({
          type: "github",
          includedScopes: isPrivate ? "private_repos" : "public_repos",
        });

        return;
      }

      track("reset_branch_to_remote", {
        event_source,
      });

      resetLocalToRemoteModal.open();
    },
    subtitle: "Reset branch to remote state",
  };
};
